import React, { useState } from "react";
import {
  Button,
  Card,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import "./styles.scss";

interface RejectModalProps {
  open: boolean;
  onClose: () => void;
  onReject: (comment: string) => void;
  title?: string;
  placeholder?: string;
  rejectButtonText?: string;
  closeButtonText?: string;
}

const RejectModal = ({
  open,
  onClose,
  onReject,
  title,
  placeholder,
  rejectButtonText,
  closeButtonText,
}: RejectModalProps) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  
  const handleReject = () => {
    onReject(comment);
    setComment("");
    onClose();
  };

  const handleClose = () => {
    setComment("");
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className="reject-modal-wrapper"
    >
      <Card className="reject-modal-card">
        <Typography variant="h5">{title || t('confirmAction')}</Typography>
        
        <TextField
          style={{ marginTop: "20px" }}
          fullWidth
          label={placeholder || t('rejectComment')}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          multiline
          rows={3}
        />

        <div className="reject-modal-btns-group" style={{ marginTop: "30px" }}>
          <Button
            variant="contained"
            onClick={handleClose}
            style={{ marginRight: "20px" }}
          >
            {closeButtonText || t('close')}
          </Button>
          <Button 
            variant="contained" 
            color="error"
            onClick={handleReject}
          >
            {rejectButtonText || t('reject')}
          </Button>
        </div>
      </Card>
    </Modal>
  );
};

export default RejectModal;
